import { initializeApp } from "firebase/app";
import { getFirestore, doc, getDoc, addDoc, onSnapshot, setDoc, serverTimestamp, collection, writeBatch } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";

  const firebaseConfig = {
    apiKey: "AIzaSyBKcd4PnhKYyK_iIykBHExqpFb4ozeHGSE",
    authDomain: "house-party-268715.firebaseapp.com",
    databaseURL: "https://house-party-268715.firebaseio.com",
    projectId: "house-party-268715",
    storageBucket: "house-party-268715.appspot.com",
    messagingSenderId: "674428671317",
    appId: "1:674428671317:web:d9c2382f818c99cd8c4bdc",
    measurementId: "G-MNSXD5909L"
  };

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);

export { analytics, db, doc, getDoc, addDoc, onSnapshot, setDoc, collection, serverTimestamp, writeBatch };